import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "sonner";
import "@/App.css";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Protected } from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import ShiftEditor from "@/pages/ShiftEditor";
import SettingsPage from "@/pages/SettingsPage";
import Premium from "@/pages/Premium";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

const Home = () => (
  <>
    <Show when="signed-in"><Navigate to="/dashboard" replace /></Show>
    <Show when="signed-out"><Landing /></Show>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign-in/*" element={<AuthPage mode="in" />} />
          <Route path="/sign-up/*" element={<AuthPage mode="up" />} />
          <Route element={<Protected />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/shifts/new" element={<ShiftEditor />} />
            <Route path="/shifts/:id/edit" element={<ShiftEditor />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
